import { ReactComponent as Logo } from '@/assets/img/logo-v2.svg';
import { ChangeEvent, useEffect, useState } from 'react';
import { showNotification } from '@/utils/notificationUtils';
import { forgotPasswordandReset } from '../../auth/api/forgotPassword';

import Utils from '@/utils/util';
import './ConsumerLogin.scss';
import { Loader } from '@/components/Loader/Loader';
import { useTranslation } from 'react-i18next';
type ForgotPasswordProps = {
  onBack: (page: 'serviceSelection') => void;
  onNext: (page: 'login' | 'email-verification') => void;
};
export const ForgotPassword = ({ onBack, onNext }: ForgotPasswordProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    Utils.scrollToTop();
  }, [])

  const handleFormChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.id === 'email') {
      setEmail(event.target.value);
    } else if (event.target.id === 'password') {
      setPassword(event.target.value);
    }
  };

  const validate = () => {
    if (!email || email.trim().length < 1 || !Utils.isValidEmail(email)) {
      showNotification({
        type: 'info',
        title: t('Please enter valid email'),
      });
      return false;
    }
    return true;
  };
  const onFPClick = async () => {
    if (validate()) {
      setIsLoading(true);
      try {
        await forgotPasswordandReset({
          email,
        });
        setIsLoading(false);
        onNext('login');
        showNotification({
          type: 'success',
          title: t('Please check your email for resetting your password.'),
        });
      } catch (error: any) {
        setIsLoading(false);
        if (
          (error && error.response && error.response.data && error.response.data.message) ||
          (error && error.message)
        ) {
          let message = error.response?.data?.message || error.message;
          let errorcode;
          if (error?.response?.data?.errors && error?.response?.data?.errors?.length > 0) {
            message = `${error.response?.data?.errors[0]?.message}`;
            errorcode = error.response?.data?.errors[0]?.code;
            if (message.includes('field is required') > 0) {
              message = `${error.response?.data?.errors[0]?.field} ${error.response?.data?.errors[0]?.message}`;
            }
            if (errorcode == 'ERR059') {
              message = t(`Please enter valid Email address.`);
            }
          }
          if (errorcode && errorcode === 'ERR067') {
            onNext('email-verification');
          }
        }
      }
    }
  };
  return (
    <section className="consumer-login">
      <div className="registration-container">
        <div className="logo-section">
          <Logo />
          <p className="petsked-desc">{t('We’ll send you a reset password link to your email address')}</p>
        </div>
        <div className="petsked-form">
          <input
            id="email"
            type="email"
            value={email}
            onChange={handleFormChange}
            placeholder={t("Email Address")}
          />
          <div className="action">
            <button className="petsked-button button-dark" onClick={onFPClick} disabled={isLoading}>
              {isLoading ? <Loader /> : <span>{t('Send Reset Email')}</span>}
            </button>
            <p className="sign-up-link" onClick={() => onNext('login')}>
              {t('Remember Password?')} <a>{t('Sign in')}</a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
